(function () {
  'use strict';

  /**
   * MOXIE — WCAG 2.1.1 / 2.4.3 — Sizebay VFR focus management
   *
   * LIMITATION (cross-origin iframe):
   *   #szb-container lives inside Sizebay's iframe document, not in the main
   *   page document. Theme JS cannot access or focus elements inside a
   *   cross-origin iframe. The ONLY thing achievable from the theme layer is
   *   focusing the <iframe> element itself, so Tab navigation enters the VFR
   *   without requiring a mouse click.
   *
   *   Full focus trap (Tab/Shift+Tab loop) and Escape handling from inside the
   *   iframe are NOT possible from the theme. Sizebay must fix those in their
   *   own application code.
   */

  var TRIGGER_SELECTOR = '#sizebay-container';
  var trigger  = null;
  var polling  = false;

  function isVisible(el) {
    if (!el || el.hidden) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  // Find the Sizebay iframe in the main document
  function findSzbIframe() {
    var frames = document.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) {
      var f   = frames[i];
      var src = f.src || f.getAttribute('src') || '';
      var id  = f.id  || '';
      var cls = typeof f.className === 'string' ? f.className : '';
      if (src.indexOf('sizebay') !== -1 ||
          id.indexOf('szb')      !== -1 ||
          cls.indexOf('szb')     !== -1) {
        if (isVisible(f)) return f;
      }
    }
    return null;
  }

  function focusIframe(iframe) {
    // Add ARIA wrapper to the nearest overlay ancestor in the main document
    var wrapper = iframe.parentElement;
    while (wrapper && wrapper !== document.body) {
      var cs = getComputedStyle(wrapper);
      if (cs.position === 'fixed' || cs.position === 'absolute') break;
      wrapper = wrapper.parentElement;
    }
    if (wrapper && wrapper !== document.body) {
      if (!wrapper.hasAttribute('role'))       wrapper.setAttribute('role', 'dialog');
      if (!wrapper.hasAttribute('aria-modal')) wrapper.setAttribute('aria-modal', 'true');
      if (!wrapper.hasAttribute('aria-label')) wrapper.setAttribute('aria-label', 'Virtual Fitting Room');
    }

    // Focus the iframe element — browser moves keyboard context into iframe content
    setTimeout(function () {
      iframe.focus();
      if (trigger) {
        // Restore trigger focus when iframe loses focus (user closes VFR)
        iframe.addEventListener('blur', function onBlur() {
          iframe.removeEventListener('blur', onBlur);
          if (trigger) { trigger.focus(); trigger = null; }
        });
      }
    }, 150);
  }

  document.addEventListener('click', function (e) {
    var container = document.querySelector(TRIGGER_SELECTOR);
    if (!container || !container.contains(e.target)) return;

    trigger = e.target.closest('button, a, [role="button"]') || e.target;

    if (polling) return;
    polling = true;
    var attempts = 0;

    function poll() {
      if (!polling || attempts++ > 60) { polling = false; return; }
      var iframe = findSzbIframe();
      if (iframe) {
        polling = false;
        focusIframe(iframe);
        return;
      }
      requestAnimationFrame(poll);
    }

    requestAnimationFrame(poll);
  }, true);

})();
